/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { accessDeleteRole } from "../funcs/accessDeleteRole.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DeleteRoleRequest,
  DeleteRoleSecurity,
} from "../models/operations/deleterole.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type DeleteRoleMutationVariables = {
  request: DeleteRoleRequest;
  security?: DeleteRoleSecurity | undefined;
  options?: RequestOptions;
};

export type DeleteRoleMutationData = void;

export type DeleteRoleMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * deleteRole access
 *
 * @remarks
 * Delete a custom role (system roles cannot be deleted).
 */
export function useDeleteRoleMutation(
  options?: MutationHookOptions<
    DeleteRoleMutationData,
    DeleteRoleMutationError,
    DeleteRoleMutationVariables
  >,
): UseMutationResult<
  DeleteRoleMutationData,
  DeleteRoleMutationError,
  DeleteRoleMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildDeleteRoleMutation(client, options),
    ...options,
  });
}

export function mutationKeyDeleteRole(): MutationKey {
  return ["@gram/client", "access", "deleteRole"];
}

export function buildDeleteRoleMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: DeleteRoleMutationVariables,
  ) => Promise<DeleteRoleMutationData>;
} {
  return {
    mutationKey: mutationKeyDeleteRole(),
    mutationFn: function deleteRoleMutationFn({
      request,
      security,
      options,
    }): Promise<DeleteRoleMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(accessDeleteRole(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
